import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge'; // --- Constants ---

var COMPONENT_UID_KEY = '_uid';
export { COMPONENT_UID_KEY, Vue, mergeData };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/vue.js
// module id = 1
// module chunks = 0